export const GET_USER_LOCATION_REQUEST = 'GET_USER_LOCATION_REQUEST'
export const GET_USER_LOCATION_SUCCESS = 'GET_USER_LOCATION_SUCCESS'

export const getUserLocationRequest = () => ({ type: GET_USER_LOCATION_REQUEST })
export const getUserLocationSuccess = (data) => {
  return ({ type: GET_USER_LOCATION_SUCCESS, data })
}
